/*global angular*/
var term = angular.module('term', []);
term.directive('term', ['termHelper', function (termHelper) {
  'use strict';
  return {
    restrict: 'E',
    template: require('./term.html'),
    replace: false,
    transclude: true,
    scope: {
      word: '@',
      key: '@',
      mode: '@'
    },
    link: function (scope, element, attrs) {
      scope.openTerm = termHelper.openTerm;
    }
  };
}]);
module.exports = term;


// WEBPACK FOOTER //
// ./web/js/module/term/term.js